import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useLocation, useNavigate } from "react-router-dom";
// import SessionWarningModal from "./SessionWarningModal";
import TpinLockModal from "./TpinLockModal";

// --- Time configurations (kept for reference / testing) ---
// const IDLE_TIME = 10 * 1000;
// const IDLE_TIME = 50 * 60 * 1000;
const IDLE_TIME = 5 * 60 * 1000; // 5 minute
// const IDLE_TIME = 10 * 1000; // 10 seconds for testing
// const IDLE_TIME = 1 * 60 * 1000; // 1 minute

// const WARNING_TIME = 10;

// const ENABLE_SESSION_TIMEOUT = false;
const ENABLE_SESSION_TIMEOUT = true;

function SessionIdleProvider({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Public paths where screen should never be locked
  const publicPaths = useMemo(
    () => [
      "/login-area",
      "/Signup",
      "/privacy-policy",
      "/refund-policy",
      "/terms-condition",
      "/session-expired",
      "/forgot-password",
      "/about",
      "/contact-us",
    ],
    []
  );

  const isPublicRoute = useMemo(() => {
    return publicPaths.some((path) => location.pathname.startsWith(path));
  }, [location.pathname, publicPaths]);

  const isLoggedIn = !!(
    localStorage.getItem("userIdToken") || localStorage.getItem("userToken")
  );

  // If user was locked before tab refresh, stay locked
  const [isLocked, setIsLocked] = useState(() => {
    return sessionStorage.getItem("is_screen_locked") === "true";
  });

  const shouldEnableIdle =
    ENABLE_SESSION_TIMEOUT && isLoggedIn && !isPublicRoute;

  // Handle idle trigger (after 5 minutes of no mouse/keyboard/scroll/touch)
  const handleOnIdle = useCallback(() => {
    if (!shouldEnableIdle) return;
    sessionStorage.setItem("is_screen_locked", "true");
    setIsLocked(true);
  }, [shouldEnableIdle]);

  const { reset } = useIdleTimer({
    timeout: IDLE_TIME,
    debounce: 500,
    enabled: shouldEnableIdle && !isLocked,
    onIdle: handleOnIdle,
  });

  // When screen is unlocked via correct TPIN
  const handleUnlock = useCallback(() => {
    sessionStorage.removeItem("is_screen_locked");
    setIsLocked(false);
    reset();
  }, [reset]);

  // When user clicks logout from lock screen
  const handleLogout = useCallback(() => {
    sessionStorage.removeItem("is_screen_locked");
    setIsLocked(false);
    localStorage.clear();
    navigate("/login-area", { replace: true });
    window.location.reload();
  }, [navigate]);

  // If user navigates to public route or logs out elsewhere, clear lock state
  useEffect(() => {
    if (isPublicRoute || !isLoggedIn) {
      if (isLocked) {
        setIsLocked(false);
        sessionStorage.removeItem("is_screen_locked");
      }
    }
  }, [isPublicRoute, isLoggedIn, isLocked]);

  return (
    <>
      {children}

      {shouldEnableIdle && isLocked && (
        <TpinLockModal
          open={isLocked}
          onUnlock={handleUnlock}
          onLogout={handleLogout}
        />
      )}
    </>
  );
}

export default SessionIdleProvider;